import React, { createContext, useContext, useEffect, useState } from "react";

const DensityContext = createContext(null);

export function DensityProvider({ children }) {
  const [density, setDensity] = useState(() => localStorage.getItem("gybc_density") || "comfortable");

  useEffect(() => {
    document.body.classList.toggle("compact", density === "compact");
    localStorage.setItem("gybc_density", density);
  }, [density]);

  const toggleDensity = () => setDensity((d) => (d === "compact" ? "comfortable" : "compact"));

  return (
    <DensityContext.Provider value={{ density, toggleDensity }}>{children}</DensityContext.Provider>
  );
}

export const useDensity = () => useContext(DensityContext);
